define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SmaCondition = void 0;
    class SmaCondition extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "SmaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SmaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Condition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConditionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Sma", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, SmaCondition.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Sma = parent;
            this.SmaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Sma = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.SmaId = (0, EntityUtil_1.toInt)(entity.SmaId);
            a.Condition = b.Condition;
            a.PermitType = (0, EntityUtil_1.toInt)(entity.PermitType);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, SmaCondition.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "PermitType", "Applicable Permit Type");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                SmaId: this.SmaId,
                Condition: this.Condition,
                PermitType: this.PermitType,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.SmaCondition = SmaCondition;
    Object.defineProperty(SmaCondition, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SmaCondition"
    });
    Object.defineProperty(SmaCondition, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SMA Condition"
    });
    Object.defineProperty(SmaCondition, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "SmaId", "Condition", "PermitType"]
    });
    Object.defineProperty(SmaCondition, "SmaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SmaCondition, "ConditionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SmaCondition, "ConditionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SmaCondition, "PermitTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SmaCondition, "PermitTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], SmaCondition.prototype, "SmaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SmaCondition.prototype, "SmaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SmaCondition.prototype, "Condition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SmaCondition.prototype, "ConditionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SmaCondition.prototype, "PermitType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SmaCondition.prototype, "PermitTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SmaCondition.prototype, "Sma", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SmaCondition.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SmaCondition.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SmaCondition.prototype, "merge", null);
});
